import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    UrlTree,
    CanActivate
} from '@angular/router';
import { Observable } from 'rxjs';
import { LgvAuth0Service } from '../services/lgv-auth0.service';
import { LgvAnalyticsService } from '../services/lgv-analytics.service';
import { tap } from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class LgvAuth0Guard implements CanActivate {
    constructor(
        private auth0Service: LgvAuth0Service, 
        private router: Router,
        private analytics: LgvAnalyticsService
    ) { }

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean> | Promise<boolean | UrlTree> | boolean {
        // Always allow embed routes to pass through without auth checking
        const currentUrl = state.url;
        if (currentUrl.startsWith('/embed/')) {
            this.analytics.trackEvent('embed_route_accessed', {
                url: currentUrl
            });
            return true;
        }

        return this.auth0Service.isAuthenticated$.pipe(
            tap(loggedIn => {
                //console.log('********** Inside LgvAuth0Guard **********');

                if (!loggedIn) {
                    try {
                        //console.log('NOT Logged in - Redirecting to Auth0');
                        this.analytics.trackEvent('auth_redirect_triggered', {
                            intended_url: currentUrl,
                            auth_type: 'auth0'
                        });
                        this.auth0Service.login();
                    }
                    catch (err) {
                        console.log('Error');
                        console.log(err);
                        this.analytics.trackError(err, 'auth0_guard_login');
                    }
                }
                else {
                    //console.log('Logged in!!!');
                    this.analytics.trackEvent('protected_route_accessed', {
                        url: currentUrl,
                        auth_type: 'auth0'
                    });

                    this.auth0Service.userProfile$.subscribe(
                        x => {
                            if (x && !x.email_verified) {
                                console.log('*** Email Not Verified ***');
                                this.analytics.trackEvent('unverified_email_access_attempt', {
                                    user_email: x.email
                                });
                                //this.router.navigate(['/default/not-verified']);
                            }
                        })
                }
            })
        );
    }
}
